const initState = {
  intervals: [],
  physicians: [],
  error: false,
  ok: false,
};

export function reportAssignment(store = initState, action) {
  if (action.type === "SET_PHYSICIANS") {
    return { ...store, physicians: action.payload };
  } else if (action.type === "SET_INTERVALS") {
    if (Array.isArray(action.payload)) {
      return { ...store, intervals: [...action.payload] };
    } else {
      return { ...store, intervals: [...store.intervals, action.payload] };
    }
  } else if (action.type === "SET_ERROR") {
    return { ...store, error: action.payload };
  } else if (action.type === "SET_OK") {
    return { ...store, ok: action.payload };
  } else if (action.type === "REMOVE_INTERVAL") {
    const intervals = store.intervals.filter((i) => i.id !== action.payload);
    return { ...store, intervals };
  } else if (action.type === "SET_LOADING") {
    return { ...store, loading: action.payload };
  }

  return store;
}
